/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetInspirationFeedQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  after?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type GetInspirationFeedQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    fixInspirationFeed: {
      __typename?: "FixInspirationFeedConnection";
      nodes: Array<{
        __typename?: "FixInspirationFeedItem";
        contentId: string;
        contentUrl: string;
        recommendationId?: string | null;
        recommendationPartition?: string | null;
      }>;
      pageInfo: {
        __typename?: "PageInfo";
        endCursor?: string | null;
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
      };
    };
  } | null;
};

export const GetInspirationFeedDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getInspirationFeed" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "first" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "after" } },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "fixInspirationFeed" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "first" },
                      value: { kind: "Variable", name: { kind: "Name", value: "first" } },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "after" },
                      value: { kind: "Variable", name: { kind: "Name", value: "after" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "nodes" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "contentId" } },
                            { kind: "Field", name: { kind: "Name", value: "contentUrl" } },
                            { kind: "Field", name: { kind: "Name", value: "recommendationId" } },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "recommendationPartition" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "pageInfo" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            { kind: "Field", name: { kind: "Name", value: "endCursor" } },
                            { kind: "Field", name: { kind: "Name", value: "hasNextPage" } },
                            { kind: "Field", name: { kind: "Name", value: "hasPreviousPage" } },
                            { kind: "Field", name: { kind: "Name", value: "startCursor" } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetInspirationFeedQuery__
 *
 * To run a query within a React component, call `useGetInspirationFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInspirationFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInspirationFeedQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetInspirationFeedQuery(
  baseOptions?: Apollo.QueryHookOptions<GetInspirationFeedQuery, GetInspirationFeedQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInspirationFeedQuery, GetInspirationFeedQueryVariables>(
    GetInspirationFeedDocument,
    options,
  );
}
export function useGetInspirationFeedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetInspirationFeedQuery,
    GetInspirationFeedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInspirationFeedQuery, GetInspirationFeedQueryVariables>(
    GetInspirationFeedDocument,
    options,
  );
}
// @ts-ignore
export function useGetInspirationFeedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetInspirationFeedQuery,
    GetInspirationFeedQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetInspirationFeedQuery, GetInspirationFeedQueryVariables>;
export function useGetInspirationFeedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInspirationFeedQuery, GetInspirationFeedQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetInspirationFeedQuery | undefined,
  GetInspirationFeedQueryVariables
>;
export function useGetInspirationFeedSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetInspirationFeedQuery, GetInspirationFeedQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetInspirationFeedQuery, GetInspirationFeedQueryVariables>(
    GetInspirationFeedDocument,
    options,
  );
}
export type GetInspirationFeedQueryHookResult = ReturnType<typeof useGetInspirationFeedQuery>;
export type GetInspirationFeedLazyQueryHookResult = ReturnType<
  typeof useGetInspirationFeedLazyQuery
>;
export type GetInspirationFeedSuspenseQueryHookResult = ReturnType<
  typeof useGetInspirationFeedSuspenseQuery
>;
export type GetInspirationFeedQueryResult = Apollo.QueryResult<
  GetInspirationFeedQuery,
  GetInspirationFeedQueryVariables
>;
